import type {ListRolesSearchInput} from "./list-roles.schema";
import {listAccessAdministrationRoles} from "@project/sdk/access-administration";
import {ListAccessAdministrationRolesResponse} from "@project/sdk/access-administration/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../shared/query/query-policies";
import {roleKeys} from "../../access-administration-keys";
import {listRolesSearchSchema} from "./list-roles.schema";

export function listRolesQueryOptions(input: ListRolesSearchInput) {
  const params = listRolesSearchSchema.parse(input);
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: roleKeys.list(params),
    queryFn: async ({signal}) =>
      ListAccessAdministrationRolesResponse.parse(
        await listAccessAdministrationRoles(params, {signal}),
      ),
  });
}
